"use client";

import { firstPurchasePromoStore } from "@/store/firstPurchasePromo";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { FirstPurchasePromoModal } from "./index";

/**
 * 全局首单优惠弹窗组件
 *
 * 这个组件应该放在应用的根级别（如 layout 或 Init 组件中），
 * 用于响应全局 store 的状态变化，在任何页面都能显示弹窗
 */
export const GlobalFirstPurchasePromoModal = observer(
  function GlobalFirstPurchasePromoModal() {
    // 自动关闭逻辑：如果已开始计时的倒计时结束，自动关闭弹窗
    useEffect(() => {
      if (
        firstPurchasePromoStore.isOpen &&
        firstPurchasePromoStore.startTime &&
        !firstPurchasePromoStore.isTimerActive
      ) {
        firstPurchasePromoStore.close();
      }
    }, [
      firstPurchasePromoStore.isOpen,
      firstPurchasePromoStore.startTime,
      firstPurchasePromoStore.isTimerActive,
    ]);

    // 只有在 timer 激活或者还没开始计时时才允许显示（为了安全）
    const isVisible =
      firstPurchasePromoStore.isOpen &&
      (!firstPurchasePromoStore.startTime ||
        firstPurchasePromoStore.isTimerActive);

    return (
      <FirstPurchasePromoModal
        open={isVisible}
        onClose={() => firstPurchasePromoStore.close()}
        onClaim={() => firstPurchasePromoStore.handleClaim()}
      />
    );
  },
);
